<template>
  <section class="medium-padding120 share-content">
    <div id="share-display" class="container">
      <div class="row full-content">
        <div class="col-12 mb-4">
          <div>
            <h2 class="heading-title">
              Share something
              <span class="real">real</span>
            </h2>
            <h2 class="heading-text">
              Trade stuff using points or cash, whichever you prefer.
            </h2>
          </div>
        </div>
        <div class="row col-12 info-content">
          <LandingPageInformationItem
            title="Save money"
            text="Find lots of free and inexpensive&nbsp;things"
            img="img/landing-page/circle-house.png"
            class="col-xs-12 col-sm-6 col-lg-6 mb-4"
          />
          <LandingPageInformationItem
            title="Share things"
            text="Lend and borrow with your friends and&nbsp;neighbors"
            img="img/landing-page/circle-crowd.png"
            class="col-xs-12 col-sm-6 col-lg-6 mb-4"
          />
          <LandingPageInformationItem
            title="Help the environment"
            text="Reuse instead of buying&nbsp;new"
            img="img/landing-page/circle-tree.png"
            class="col-xs-12 col-sm-6 col-lg-6"
          />
          <LandingPageInformationItem
            title="Simplify your life"
            text="Declutter and get rid of all the things you no longer&nbsp;need"
            img="img/landing-page/circle-clothes.png"
            class="col-xs-12 col-sm-6 col-lg-6"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LandingPageInformationItem from "@/components/molecules/LandingPageInformationItem.vue";

export default {
  name: "FindPeopleSectionLandingPage",
  components: {
    LandingPageInformationItem,
  },
};
</script>

<style scoped>
@media screen and (max-width: 1023px) {
  .mobile-break {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.medium-padding120 {
  background-color: $light;
}
.heading-title,
.heading-text {
  text-align: center;
  font-size: 25px;
  letter-spacing: 1.25px;
}
.heading-title {
  font-weight: bold;
  text-transform: uppercase;
  color: $black;
  font-size: 25px;
}
.real {
  color: $primary;
}
.heading-text {
  line-height: 25px;
  color: rgba(0, 0, 0, 0.6);
}
.info-content {
  max-width: 40%;
  display: contents;
}
#share-display {
  width: 40%;
  margin-inline: auto;
}
@media screen and (max-width: 1199px) {
  #share-display {
    width: 80%;
    margin-inline: auto;
  }
}
.full-content {
  margin: 0;
}
</style>
